var _        = require('underscore');
var $        = require('jquery');
var Velocity = require('velocity-animate');

var Core     = require('../core/core.js');
var TrayTabs = require('./tray__tabs.js');

/**
 * Creates an overlay tray
 *
 * @class
 */

class Tray extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'initial_show': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__tray js-editor__tray">
                <div class="editor__tray__inner js-editor__tray__inner"></div>
                <div class="editor__tray__draggable editor__tray__draggable--top js-editor__tray__draggable"></div>
            </div>
        `;

        super.render();

        // hide at first
        if(!this._options.fields['initial_show'])
            this.$el.css('opacity', 0);

        /**
         * Click event
         *
         * @fires Tray#_clicked
         */

         $('.js-editor__tray__draggable', this.$el).on('mousedown', this._clicked);

    }

    /**
     * @event Tray#Cioui:Tray:Drag:MouseDown
     * @property {String}Cioui:Tray:Drag:MouseDown
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:Tray:Drag:MouseDown', e);
    }

    /**
     * Adds a tabs interface to the tray
     */
    addTabs(){
        return new TrayTabs({
            target: $('.js-editor__tray__inner', this.$el),
        });
    }

    /**
     * Show the tray
     * @param {Function} completeCallBack - optional function that gets called on complete
     */
    show(completeCallBack){
        this.$el.show();
        this.$el.css('pointer-events', 'auto');
        Velocity(this.$el, "stop");
        Velocity(this.$el, {
            'translateY': [0, 100],
            'opacity': 1.0
        },{
            duration: 220,
            easing: "easeInOutCubic",
            complete: function () {
                if (typeof completeCallBack === 'function') {
                    completeCallBack();
                }
            }
        });
    }

    /**
     * Hide the tray
     */
    hide(){
        var self = this;

        Velocity(this.$el, "stop");
        Velocity(this.$el, {
            'translateY': [100, 0],
            'opacity': 0
        },{
            duration: 220,
            easing: "easeInOutCubic",
            complete: function(){
                self.$el.hide();
            }
        });
    }

    /**
     * Set height
     * @param {Integer} height - set height, calculated from bottom
     */
    setHeight(height){
        if(isNaN(height))
            this.$el.css('height', height);
        else
            this.$el.css('height', height+'px');
    }


}
module.exports = Tray;